import React from "react"
import { graphql } from "gatsby"
import Wysiwyg from "../../Wysiwyg"

const ThreeColGrid = ({ section }) => {
  return section?.map((row, index) => {
    return (
      <div
        key={index}
        className="relative mx-auto flex max-w-5xl flex-row flex-wrap border-b-[2px] border-b-lightGrey px-[15px] pt-[66px] pb-[73px] md:px-0 "
      >
        <h2 className="mb-[30px] w-full px-[15px] text-darkBlue md:mb-0  md:w-1/3  ">
          {row?.headline}
        </h2>
        {row?.firstColumn && row?.secondColumn && (
          <div className="mx-[10px] flex w-full min-w-[180px] flex-col justify-around px-[7px]  sm:flex-row md:mx-0 md:w-1/2 md:px-0">
            {row?.firstColumn && <Wysiwyg content={row?.firstColumn} />}
            {row?.secondColumn && <Wysiwyg content={row?.secondColumn} />}
          </div>
        )}
        {row?.firstColumn && !row?.secondColumn && (
          <div className="mx-[10px] flex w-full min-w-[180px] flex-col justify-around px-[7px] sm:flex-row  md:mx-0 md:w-1/2  md:px-0">
            {row?.firstColumn && <Wysiwyg content={row?.firstColumn} />}
            <div className="min-w-[180px]"></div>
          </div>
        )}
        {!row?.firstColumn && row?.secondColumn && (
          <div className="mx-[10px] flex w-full min-w-[180px] flex-col justify-around  px-[7px] sm:flex-row md:mx-0 md:w-1/2 md:px-0">
            <div className="min-w-[180px]"></div>
            {row?.secondColumn && <Wysiwyg content={row?.secondColumn} />}
          </div>
        )}
      </div>
    )
  })
}

export default ThreeColGrid

export const fragment = graphql`
  fragment ThreeColGrid on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_ThreeColGrid {
      fieldGroupName
      section {
        firstColumn
        secondColumn
        headline
      }
    }
  }
`
